import React from "react";

// import {introductionPageAssetConfig} from "../../../../data/introduction/index"


interface IframeworkMobViewPanel {
    data: {}
}

export const frameworkMobViewPanel: IframeworkMobViewPanel = {
    data: {
        "COMPONENTS": []
    }

};
export const mobViewPanelConfigurationContext = React.createContext(
    {}
);